import * as React from 'react'
import { AppBar, Box, Toolbar, IconButton, Typography, Menu, Avatar, Tooltip, MenuItem } from '@mui/material'
import evrolablogo from '../../assets/img/eurolablogo.png'
import { Link } from 'react-router-dom'
import LangSelect from '../Localization/LangSelect'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { resetLogin } from '../../API/auth'
import { useState, useEffect } from 'react'
import { getUsername } from '../../API/api'
function ResponsiveAppBar() {
	const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null)
	const { t } = useTranslation()
	const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorElUser(event.currentTarget)
	}
	const handleCloseUserMenu = () => {
		setAnchorElUser(null)
	}
	const navigate = useNavigate()
	const logOut = () => {
		resetLogin()
		navigate('/login')
	}

	const [localName, setLocaleName] = useState<string | undefined>('')

	useEffect(() => {
		const fetchOption = async () => {
			try {
				const data = await getUsername()
				if (data.error) {
					return
				}
				if (!data.data) return
				setLocaleName(data.data)
			} catch (error) {
				console.error('Error fetching data:', error)
			}
		}
		fetchOption()
	}, [])

	return (
		<AppBar position='static'>
			<Toolbar disableGutters sx={{ pl: 3, pr: 5 }}>
				<Link to='/'>
					<img src={evrolablogo} alt='evrolabLogo' width={70} />
				</Link>
				<Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}></Box>
				<Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}></Box>
				<Box sx={{ flexGrow: 0 }}>
					<Tooltip title='Open settings'>
						<IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
							<Avatar></Avatar>
						</IconButton>
					</Tooltip>
					<Menu
						sx={{ mt: '45px' }}
						id='menu-appbar'
						anchorEl={anchorElUser}
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'right',
						}}
						keepMounted
						transformOrigin={{
							vertical: 'top',
							horizontal: 'right',
						}}
						open={Boolean(anchorElUser)}
						onClose={handleCloseUserMenu}
					>
						<MenuItem>{localName}</MenuItem>
						<MenuItem>
							<LangSelect />
						</MenuItem>
						<MenuItem onClick={handleCloseUserMenu}>
							<Typography textAlign='center' onClick={logOut}>
								{t('logOut')}
							</Typography>
						</MenuItem>
					</Menu>
				</Box>
			</Toolbar>
		</AppBar>
	)
}
export default ResponsiveAppBar
